export const regexForURL = new RegExp(
  /(https?:\/\/(?:www\.|(?!www))?[^\s.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,})/gi,
);

export const isStringURL = (str: string) => {
  return regexForURL.test(str);
};
